export class SubmissionTypeConfigConstants {
    public static submissionTypeListAlias: string = "submission_type";
    public static indicatorListAlias: string = "env_indicator";
    public static meterReferenceListAlias: string = "env_meter_reference";
    public static defaultSidebarTitle: string = "Add Submisson Type";
    public static defaultSubmissionTypeLabel: string = "Submission Type";
}
export class SubmitionTypeConfigIconNames {
    public static submissionTypeIcon: string = "assignment";
    public static indicatorListIcon: string = "assessment";
    public static meterReferenceIcon: string = "bar_chart";
}

//0 is level 1 as this is not planed to add more 0 level items
export const submissionNewNodeLevelToListAlias: Map<number, { listAlias: string, iconName: string, label: string }> = new Map<number, { listAlias: string, iconName: string, label: string }>()
    .set(0, { listAlias: SubmissionTypeConfigConstants.submissionTypeListAlias, iconName: SubmitionTypeConfigIconNames.submissionTypeIcon, label: "Submission Type" })
    .set(1, { listAlias: SubmissionTypeConfigConstants.indicatorListAlias, iconName: SubmitionTypeConfigIconNames.indicatorListIcon, label: "Indicator" })
    .set(2, { listAlias: SubmissionTypeConfigConstants.meterReferenceListAlias, iconName: SubmitionTypeConfigIconNames.meterReferenceIcon, label: "Meter" });
